<template>
    <div class="black--text">
        <label class="v-label theme--light">{{label}}</label>
        <!--        <div v-for="product in products" :key="product.id">
            {{product.id}} {{product.name}} {{ product.variants}}
        </div> -->

        <div v-if="hint" v-text="hint" />

        <v-list :key="renderKey">
            <draggable v-model="productlist" @change="$emit('input', productlist); $emit('change')" tag="ContentsContainer">
                <v-list-item v-for="(item,itemindex) in displaylist" :key="item.product_id + item.variant" class="d-flex">
                    <v-avatar size="32" class="mr-2" v-if="item.product">
                        <v-auto-img :src="item.product.imagekey ? item.product.imagekey : undefined" height="32" width="32" />
                    </v-avatar>
                    <div class="flex-grow-1"><span v-if="item.count != 1">{{item.count}} x&nbsp;</span>{{item.product ? item.product.name : 'Okänd produkt'}}<span v-if="item.variant">, {{item.variant}}</span>
                        <span v-if="item.price">, {{item.price | price}}</span>
                    </div>
                    <v-btn
                        @click="removeItem(itemindex)"
                        color="error"
                        fab
                        small
                    >
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </v-list-item>
            </draggable>
        </v-list>

        <div class="d-flex">
            <v-text-field :label="$translate('Quantity')" v-model.number="newProduct.count" type="number" style="max-width: 50px" :disabled="payWhatYouWant" min=1 :rules="[countPositive]" />
            <zoezi-autocomplete :label="$translate('Product')" class="flex-grow-1 mx-2" :items="products" item-text="name" item-value="id" v-model="newProduct.product_id" />

            <v-btn
                @click="addItem()"
                color="zoezi-edit-color"
                small
                fab
                :disabled="!newProductValid"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </div>
        <div v-if="newProduct.product_id && getVariants(newProduct).length > 1">
            <zoezi-autocomplete label="Variant" :items="getVariants(newProduct)" item-text="name" item-value="name" v-model="newProduct.variant" />
        </div>
        <div v-if="newProduct.product_id && products.find(p => p.id == newProduct.product_id).payWhatYouWant">
            <v-text-field label="Belopp" v-model.number="newProduct.price" type="number" :rules="[amountPositive]" />
        </div>
    </div>
</template>

<script>
import Draggable from 'vuedraggable';
import ZoeziAutocomplete from '../components/ui/form/Autocomplete.vue';

export default {
    name: 'ProductListSetting',

    props: ['value', 'label', 'hint'],

    components: {
        Draggable,
        ZoeziAutocomplete,
    },

    data: () => ({
        renderKey: 0,
        productlist: [],
        newProduct: {
            product_id: null,
            count: 1,
            variant: null,
            price: null
        }
    }),

    watch: {
        payWhatYouWant(p) {
            if (p) {
                this.newProduct.count = 1;
            }
        }
    },

    computed: {
        products() {
            return this.$store.getters.allProducts.filter(p => p.type != 'course').sort((a,b) => a.name.localeCompare(b.name));
        },
        displaylist() {
            let clean = function(obj) {
                obj = Object.assign({}, obj);
                for (var propName in obj) {
                    if (obj[propName] === null || obj[propName] === undefined) {
                        delete obj[propName];
                    }
                }
                return obj;
            };

            return this.productlist.map(x => {
                return {
                    product: this.products.find(p => p.id == x.product_id),
                    ...clean(x)
                }
            });
        },
        newProductValid() {
            let alreadyInList = this.productlist.find(x => x.product_id == this.newProduct.product_id && x.variant == this.newProduct.variant);
            return this.newProduct.product_id && (this.newProduct.variant || this.getVariants(this.newProduct).length <= 1) && !alreadyInList && this.newProduct.count > 0;
        },
        payWhatYouWant() {
            return this.newProduct.product_id && this.products.find(p => p.id == this.newProduct.product_id).payWhatYouWant;
        }
    },

    methods: {
        removeItem(itemindex) {
            this.productlist.splice(itemindex, 1);
            this.$emit('input', this.productlist);
            this.$emit('change');
            ++this.renderKey;
        },
        addItem() {
            let newitem = Object.assign({}, this.newProduct);
            this.productlist.splice(this.productlist.length, 0, newitem);
            this.$emit('input', this.productlist);
            this.$emit('change');
            ++this.renderKey;

            Object.assign(this.newProduct, {product_id: null, count: 1, variant: null, price: null})
        },
        getVariants(x) {
            let product = this.products.find(p => p.id == x.product_id);
            return product.variants || [];
        },
        amountPositive(x) {
            if (x && Number(x) > 0) {
                return true;
            }

            return this.$translate('Enter amount')
        },
        countPositive(x) {
            if (x && Number(x) > 0) {
                return true;
            }

            return this.$translate('Enter quantity')
        }
    },

    created() {
        this.productlist = this.value;
    },

    mounted() {
        this.$store.dispatch('loadProducts');
    }
}
</script>
